import api from '@/api';

import {
  MatrixCreateResponse,
  UpdateMatrixIntercompanyInvoice,
  UpdateMatrixMichelinSupplier,
} from './Matrix.types';

import { API_BASE_URL } from '..';
import {
  MatrixSettings,
  RegisterMatrix,
  UpdateMatrixSettingsRequest,
} from '@/types/Register';

const CONTROLLER_URL = `${API_BASE_URL}/matrices`;

export async function createMatrix(
  obj: RegisterMatrix,
): Promise<MatrixCreateResponse> {
  const result = (await api.post(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result as MatrixCreateResponse;
}

export async function getMatrix(): Promise<MatrixSettings> {
  const result = (await api.get(`${CONTROLLER_URL}`, {})) as unknown;

  return result as MatrixSettings;
}

export async function getUpdateMatrix(obj: UpdateMatrixSettingsRequest) {
  const result = (await api.put(`${CONTROLLER_URL}`, obj, null)) as unknown;

  return result;
}

export async function updateMatrixIntercompanyInvoice(
  data: UpdateMatrixIntercompanyInvoice,
) {
  const result = (await api.patch(
    `${CONTROLLER_URL}/intercompany-invoice`,
    data,
    null,
  )) as unknown;

  return result as void;
}

export async function updateMatrixMichelinSupplier(
  data: UpdateMatrixMichelinSupplier,
) {
  const { matrixSettingsId, supplierId } = data;

  let url = `${CONTROLLER_URL}/matrix-settings/${matrixSettingsId}/michelin-supplier`;

  if (supplierId !== undefined && supplierId !== null) {
    url += `?supplierId=${supplierId}`;
  }

  return await api.patch(url, {}, null);
}
